import { h, render } from 'preact';

const MobileScrollingNav = ({ menu }) => {
  if (!menu.length) return null;

  return (
    <div className="bg-neutral laptop:hidden mr-auto w-full border-b border-black-30 overflow-x-auto pt-[7px] pb-3">
      <ul className="flex gap-[18px]">
        {menu?.map((link) => (
          <li
            key={`${link.title}-${link.url}`}
            className="leading-none first:pl-[21px] last:pr-[21px]"
          >
            <a
              href={link.url}
              className="utility-1 leading-[1] font-medium tracking-[0.02em] uppercase whitespace-nowrap"
            >
              {link.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default (element, data) => {
  const init = () => {
    render(<MobileScrollingNav menu={data?.menu} />, element);
  };

  init();
};
